import { getBugsnagClient } from '@app/core/integrations/bugsnag/bugsnag';
import { FatalError, FatalErrorScreen } from '@mi-front/ui';
import React, { PropsWithChildren } from 'react';

export const BugsnagErrorBoundary = getBugsnagClient()
  ?.getPlugin('react')!
  .createErrorBoundary(React);

export const ErrorBoundary = (
  p: PropsWithChildren<{
    errScreen: boolean;
  }>,
) => {
  if (!BugsnagErrorBoundary) {
    return <>{p.children}</>;
  }

  return (
    <BugsnagErrorBoundary
      FallbackComponent={
        p.errScreen
          ? FatalErrorScreen
          : () => (
              <div className="col-md-6 mx-auto mt-7">
                <FatalError />
              </div>
            )
      }
    >
      {p.children}
    </BugsnagErrorBoundary>
  );
};
